import React from "react";
import PropTypes from "prop-types";
import { Box, Flex, Icon, Text } from "orcs-design-system";
import styled from "styled-components";
import SuggestedPrompts from "./SuggestedPrompts";

const WelcomeContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px 16px;
`;

const IconCircle = styled(Box)`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.colors.blue};
  font-size: 60px;
`;

const GreetingText = styled(Text)`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.bodyText};
`;

const QuestionText = styled(Text)`
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.subText};
  margin-bottom: 24px;
`;

/**
 * AIChatWelcome component - displays the welcome screen with user greeting and suggested prompts
 * @param {Object} props
 * @param {string} props.userName - The user's name
 * @param {string} props.userRole - The user's role/title
 * @param {Function} props.onPromptSelect - Callback when a prompt is selected
 * @param {boolean} props.showSuggestions - Whether to show suggested prompts
 */
const AIChatWelcome = ({
  userName,
  onPromptSelect,
  showSuggestions = true,
}) => {
  return (
    <WelcomeContainer>
      {/* Chat Icon */}
      <IconCircle>
        <StyledIcon icon={["fas", "comments-alt"]} />
      </IconCircle>

      {/* Greeting */}
      <Flex flexDirection="column" alignItems="center" gap="xs" mb="r">
        <GreetingText>Hey {userName}</GreetingText>
      </Flex>
      <QuestionText>How can TeamForm help?</QuestionText>

      {/* Suggested Prompts */}
      {showSuggestions && <SuggestedPrompts onPromptSelect={onPromptSelect} />}
    </WelcomeContainer>
  );
};

AIChatWelcome.propTypes = {
  userName: PropTypes.string.isRequired,
  onPromptSelect: PropTypes.func.isRequired,
  showSuggestions: PropTypes.bool,
};

export default AIChatWelcome;
